import React, { useEffect } from 'react';
import { DraftProfile } from '../../services/draftStorageService';
import SavedDraftsList from './SavedDraftsList';
import './saved-drafts-popup.scss';

interface SavedDraftsDrawerProps {
  open: boolean;
  drafts: DraftProfile[];
  isLoading?: boolean;
  onSelectDraft: (draft: DraftProfile) => void;
  onClose: () => void;
  onDraftDeleted: () => void;
}

const SavedDraftsDrawer: React.FC<SavedDraftsDrawerProps> = ({
  open,
  drafts,
  isLoading = false,
  onSelectDraft,
  onClose,
  onDraftDeleted,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="saved-drafts-drawer-root" aria-modal="true" role="dialog" aria-labelledby="saved-drafts-drawer-title">
      <button type="button" className="saved-drafts-drawer-backdrop" onClick={onClose} aria-label="إغلاق" />
      <div className="saved-drafts-drawer-panel">
        <div className="saved-drafts-header">
          <h3 id="saved-drafts-drawer-title">المحادثات السابقة</h3>
          <button type="button" className="saved-drafts-close" onClick={onClose} aria-label="إغلاق">
            ✕
          </button>
        </div>
        <div className="saved-drafts-content saved-drafts-drawer-content">
          <SavedDraftsList
            drafts={drafts}
            isLoading={isLoading}
            onSelectDraft={onSelectDraft}
            onDraftDeleted={onDraftDeleted}
          />
        </div>
      </div>
    </div>
  );
};

export default SavedDraftsDrawer;
